(function () {
  var stringsNode = document.getElementById("ThemeStrings");
  var strings = {};

  if (stringsNode) {
    try {
      strings = JSON.parse(stringsNode.textContent);
    } catch (error) {
      strings = {};
    }
  }

  var header = document.querySelector(".site-header");
  var navToggle = document.querySelector("[data-nav-toggle]");

  if (header && navToggle) {
    navToggle.addEventListener("click", function () {
      var isOpen = header.classList.toggle("is-open");
      navToggle.setAttribute("aria-expanded", String(isOpen));

      var label = navToggle.querySelector(".visually-hidden");
      if (label) {
        label.textContent = isOpen ? strings.menuClose : strings.menuOpen;
      }
    });
  }

  var quantityInputs = document.querySelectorAll("[data-quantity-input]");

  quantityInputs.forEach(function (input) {
    input.addEventListener("change", function () {
      input.setAttribute("aria-label", strings.quantityChanged || "");
    });
  });
})();
function cleanGeneratedPolicyCopy(replacements) {
  if (!window.location.pathname.includes('/policies/')) return;

  const main = document.querySelector('main');
  if (!main) return;

  const walker = document.createTreeWalker(main, NodeFilter.SHOW_TEXT);
  const textNodes = [];
  while (walker.nextNode()) textNodes.push(walker.currentNode);

  textNodes.forEach((node) => {
    let value = node.nodeValue;
    replacements.forEach(([from, to]) => { value = value.split(from).join(to); });
    node.nodeValue = value;
  });

  main.querySelectorAll('a[href]').forEach((link) => {
    let href = link.getAttribute('href');
    replacements.forEach(([from, to]) => { href = href.split(from).join(to); });
    link.setAttribute('href', href);
  });
}

cleanGeneratedPolicyCopy([
  ['pharmamisr', 'Night Desk Pharmacy'],
  ['care@example.com', 'info@pyranext.com'],
  ['warherome@gmail.com', 'info@pyranext.com'],
  ['+20 100 000 0000', 'info@pyranext.com']
]);
